// Admin dashboard: a grid of cards linking to each management area. Areas not
// yet built in this phase are shown disabled with a "Coming soon" note so the
// full surface is visible without implying it's clickable.
import { Link as RouterLink } from 'react-router';
import {
  Box, Card, CardActionArea, CardContent, Typography, Chip,
} from '@mui/material';

const SECTIONS = [
  {
    to: '/admin/catalog', title: 'Catalog', description: 'Categories, products, options, and pricing on one drag-and-drop board.', ready: true,
  },
  {
    to: '/admin/pricing', title: 'Pricing', description: 'All per-square-mile rates in one editable matrix.', ready: true,
  },
  {
    to: '/admin/blacklist', title: 'Email Blacklist', description: 'Blocked domains and addresses for the contact gate.', ready: true,
  },
  {
    to: '/admin/branding', title: 'Branding', description: 'Theme colors and public page content, with WCAG contrast checks.', ready: true,
  },
  {
    to: '/admin/settings', title: 'Portal Settings', description: 'Region vocabulary: display name and subdivision terms.', ready: true,
  },
  {
    to: '/admin/inquiries', title: 'Inquiries', description: 'Submitted pricing requests and their details.', ready: true,
  },
];

const AdminDashboardPage = () => (
  <Box>
    <Typography variant="h4" component="h1" sx={{ fontWeight: 700, mb: 1 }}>
      Dashboard
    </Typography>
    <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
      Manage the public intake portal.
    </Typography>

    <Box sx={{
      display: 'grid',
      gap: 3,
      gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: '1fr 1fr 1fr' },
    }}
    >
      {SECTIONS.map((section) => {
        const cardContent = (
          <CardContent>
            <Box sx={{
              display: 'flex', alignItems: 'center', gap: 1, mb: 1,
            }}
            >
              <Typography variant="h6" component="h2" sx={{ fontWeight: 700 }}>
                {section.title}
              </Typography>
              {!section.ready && <Chip label="Coming soon" size="small" />}
            </Box>
            <Typography variant="body2" color="text.secondary">
              {section.description}
            </Typography>
          </CardContent>
        );

        return (
          <Card
            key={section.to}
            variant="outlined"
            sx={{ opacity: section.ready ? 1 : 0.6 }}
          >
            {section.ready ? (
              <CardActionArea component={RouterLink} to={section.to} sx={{ height: '100%' }}>
                {cardContent}
              </CardActionArea>
            ) : (
              cardContent
            )}
          </Card>
        );
      })}
    </Box>
  </Box>
);

export default AdminDashboardPage;
